/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography } from '@material-ui/core'
import * as React from 'react'

import { containerStyles } from '../../styles/ContainerStyles'
import { formatSeconds } from '../../utils/helper'
import { StartedGameDto } from '../../utils/types'
import { ContinueButton } from '../atoms/ContinueButton'
import { VideoPlayer } from './VideoPlayer'

interface Props {
    game: StartedGameDto
    secondsLeft: number
    onComplete(): void
}

export const GameWinnerView: React.FC<Props> = ({ game, secondsLeft, onComplete }) => {
    const styles = containerStyles()
    return (

        <div className={styles.lostTimerDiv}>
            <Typography style={{ color: 'white' }} variant="h5">
                Tillykke! I klarede tidsrejsen
            </Typography>
            <div style={{ width: '100%' }}>
                <VideoPlayer videoUri="https://vimeo.com/534583669/c93a2b05d8" autoplay/>
            </div>
            <Typography style={{ color: 'white', marginBottom: 10 }} variant="h5">
                Med hele
                <span style={{ margin: 5 }} className={styles.timerContainer}>
                    {formatSeconds(secondsLeft)}
                </span> tilbage!
            </Typography>

            <div style={{ marginTop: 10 }} className={styles.lostBtnDiv}>
                <ContinueButton title="Afslut tidsrejse!" onClick={onComplete}/>
            </div>
        </div>
    )
}
